<template>
  <div id="app">
    <NavBar :genres="genres" @search="handleSearch" />
    <router-view :searchQuery="searchObject" />
    <FooterPage />
  </div>
</template>

<script>
import NavBar from './components/NavBar.vue';
import FooterPage from './components/FooterPage.vue';

export default {
  name: "App",
  components: { NavBar, FooterPage },
  data() {
    return {
      searchObject: { query: "", genre: null },
      genres: []
    };
  },
  methods: {
    handleSearch(payload) {
      this.searchObject = payload;
    },
    async fetchGenres() {
      const apiKey = "032df6282bf9cdfb83732001903e8c27";
      try {
        const res = await fetch(
          `https://api.themoviedb.org/3/genre/movie/list?api_key=${apiKey}&language=en-US`
        );
        const data = await res.json();
        this.genres = data.genres;
      } catch (err) {
        console.error("Failed to load genres:", err);
      }
    }
  },
  mounted() {
    this.fetchGenres();
  }
};
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
  background-color: rgb(44, 43, 43);
  font-family: Arial, sans-serif;
  min-height: 100%;
}

#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

router-view {
  flex: 1;
}
</style>
